// Norwegian labels for sale.tripletexDebug[0].sentToCustomerReason, which the
// backend writes in English (backend/lib/tripletex-auto-send.js and
// integrations/tripletex/post-invoices.js). The English wordings are stable
// identifiers; a text we do not know falls through unchanged.
const EXACT_LABELS = {
    'Auto-send is not enabled. Enable \'Tripletex - Send Invoice To Customer\' in customer settings.':
        'Automatisk sending er ikke slått på. Slå på «Tripletex - Send faktura til kunde» i klinikkinnstillingene.',
    'Invoice is already paid. Paid invoices are not sent to customers.':
        'Fakturaen er allerede betalt. Betalte fakturaer sendes ikke til kunden.',
    'Invoice was sent to customer.':
        'Fakturaen ble sendt til kunden.',
    'Partially paid sale: invoice sent to customer after registering the payments.':
        'Delvis betalt salg: fakturaen ble sendt til kunden etter at betalingene ble registrert.',
    'Customer send method is EMAIL but the customer has no email address. Add an email to the customer/visitor.':
        'Kundens sendemåte er e-post, men kunden mangler e-postadresse. Legg inn e-post på eieren.',
    'Customer send method is EHF but the customer has no organization number.':
        'Kundens sendemåte er EHF, men kunden mangler organisasjonsnummer.',
    'Invoice was sent to customer (after attaching the invoice PDF).':
        'Fakturaen ble sendt til kunden (etter at faktura-PDF ble lagt ved).',
};

const PATTERN_LABELS = [
    [/^Customer send method '(.+)' is not supported for auto-sending\.$/,
        m => `Kundens sendemåte «${m[1]}» støttes ikke for automatisk sending.`],
    [/^EHF\/send failed \((.+)\)\. Invoice created without sending\./s,
        m => `EHF-sending feilet (${m[1]}). Fakturaen ble opprettet uten å sendes. `
            + 'Tripletex-kunden er byttet til e-post; EHF prøves igjen ved neste overføring.'],
    [/^Sending failed \((.+)\)\. Invoice created without sending;/s,
        m => `Sending feilet (${m[1]}). Fakturaen ble opprettet uten å sendes. `
            + 'Send den med «Send nå» eller fra Tripletex.'],
    [/^Invoice was created, but sending \((\w+)\) after attaching the PDF failed\./,
        m => `Fakturaen ble opprettet, men sending (${m[1]}) etter vedlegg av PDF feilet. `
            + 'Send den manuelt med «Send nå» eller fra Tripletex.'],
];

export function tripletexSendReasonLabel(reason) {
    if (typeof reason !== 'string' || !reason) {
        return reason;
    }
    const trimmed = reason.trim();
    if (EXACT_LABELS[trimmed]) {
        return EXACT_LABELS[trimmed];
    }
    for (const [pattern, toLabel] of PATTERN_LABELS) {
        const match = trimmed.match(pattern);
        if (match) {
            return toLabel(match);
        }
    }
    return reason;
}

// A split sale (card at the desk, rest on invoice): status 3 «Delvis» /
// paymentMethod 'partial' and not yet settled. Tripletex prints the invoice
// total, not the remaining amount, so such invoices must not be sent from
// Tripletex; the Dyrejournal print shows paid amount, rest and KID.
export function isPartiallyPaidSale(sale) {
    if (!sale || sale.paidDate || sale.status === 1) {
        return false;
    }
    return sale.status === 3 || sale.paymentMethod === 'partial';
}

export default tripletexSendReasonLabel;
